<template>
  <div>
    <div class="card card-custom">
      <div class="card-header">
        <h3 class="card-title" style="width: 100%">
          <button onclick="javascript:location.href='../UIC/City'" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
        </h3>
      </div>
      <div class="card-body">
        <table class="table table-sm table-bordered" id="myTable">
          <thead class="bg-custom">
            <tr>
              <th width="5%">Sr.</th>
              <th width="30%">City Name</th>
              <th width="30%">Province Name</th>
              <th width="30%">Country Name</th>
              <th width="5%">Active</th>
              <th width="5%">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, ind) in list" :key="ind">
              <td>{{ ind + 1 }}</td>
              <td>{{ item.CTY_NAME }}</td>
              <td>{{ item.PVN_NAME }}</td>
              <td>{{ item.C_NAME }}</td>
              <td><input type="checkbox" :checked="item.CTY_ISACTIVE === 'Y'" disabled></td>

              <td>
                <button class="btn btn-primary btn-sm" @click="editcity(item.CTY_ID)"><i class="fas fa-pencil-alt" /></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    data() {
      return {
        list: [],
      };
    },

    created() {
      this.pageload();
    },
    updated() {
      $("#myTable").DataTable();
    },
    methods: {
      pageload() {
        var vm = this;
        startReq();
        axios.get('/api/UICApi/pageLoadCityList')
          .then((res) => {
            endReq();
            if (res.data.status) {
              vm.list = res.data.list;
            } else {
              toastr.error(res.data.msg);
            }
          })
          .catch((error) => {
            endReq();
          });
      },
      editcity(id) {
        window.open("/UIC/City?id=" + id);
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ims/CityList.vue